import React from 'react';
import Button from '@components/common/Button';
import ErrorState from '@components/common/ErrorState';
import styles from './DashboardSectionError.module.css';

interface DashboardSectionErrorProps {
  message: string;
  onRetry: () => void;
  dataTestId?: string;
}

/** Retry message shown in place of one dashboard section whose request failed; the rest of the page stays usable. */
const DashboardSectionError: React.FC<DashboardSectionErrorProps> = ({ message, onRetry, dataTestId }) => (
  <ErrorState
    className={styles.error}
    icon={null}
    message={message}
    role="alert"
    data-test-id={dataTestId}
    action={
      <Button variant="secondary" size="sm" onClick={onRetry}>
        Retry
      </Button>
    }
  />
);

export { DashboardSectionError };
